<script>
	import { fade, scale } from 'svelte/transition';
</script>

<h1 in:scale out:fade>Loading...</h1>